import * as R from 'ramda'
import { MessageActionTypes } from '@weblite/ts-action/message'
import { getUserFirstName, useUser } from '$logic/users'
import { useMessageAction } from '$logic/message-action/react-hook'
import { ACTION_MAPPER } from './chat-list-item-hooks'
import { t } from '$i18n'

function SingleUserAction({
  messageActions,
}: {
  messageActions: { userId: string; action: MessageActionTypes }[]
}) {
  const { user } = useUser(messageActions[0].userId)
  const actionTitle = ACTION_MAPPER[messageActions[0].action]

  return (
    <>
      {`${getUserFirstName(user)} `}
      {actionTitle}
    </>
  )
}

function DoubleUserAction({
  messageActions,
}: {
  messageActions: { userId: string; action: MessageActionTypes }[]
}) {
  const actionTitle = ACTION_MAPPER[messageActions[0].action]
  const secondActionTitle = ACTION_MAPPER[messageActions[1].action]

  const { user: user1 } = useUser(messageActions[0].userId)
  const { user: user2 } = useUser(messageActions[1].userId)

  if (messageActions[0].action === messageActions[1].action)
    return (
      <>
        {`${getUserFirstName(user1)} و ${getUserFirstName(
          user2,
        )} ${actionTitle}`}
      </>
    )

  if (messageActions[0].userId === messageActions[1].userId)
    return <>{`${getUserFirstName(user1)} ${secondActionTitle}`}</>

  return <>{`${getUserFirstName(user1)} و ${getUserFirstName(user2)} ...`}</>
}

function ManyUserAction({
  messageActions,
}: {
  messageActions: { userId: string; action: MessageActionTypes }[]
}) {
  const lastMessageActions = R.takeLast(3, messageActions)

  const { user: user1 } = useUser(lastMessageActions[0].userId)
  const { user: user2 } = useUser(lastMessageActions[1].userId)
  const { user: user3 } = useUser(lastMessageActions[2].userId)

  const uniqUserIds = R.uniq(R.pluck('userId', lastMessageActions))

  if (uniqUserIds.length === 1) {
    const thirdActionTitle = ACTION_MAPPER[lastMessageActions[2].action]
    return <>{`${getUserFirstName(user1)} ${thirdActionTitle}`}</>
  }

  if (uniqUserIds.length === 2) {
    if (lastMessageActions[2].userId === lastMessageActions[1].userId)
      return (
        <>{`${getUserFirstName(user3)} و ${getUserFirstName(user1)} ...`}</>
      )
    if (lastMessageActions[2].userId === lastMessageActions[0].userId)
      return (
        <>{`${getUserFirstName(user3)} و ${getUserFirstName(user2)} ...`}</>
      )
    return <>{`${getUserFirstName(user3)} و ${getUserFirstName(user2)} ...`}</>
  }

  return (
    <>
      {`${getUserFirstName(user3)} و ${getUserFirstName(user2)} ${t(
        'chat.tooManyOtherPeople',
      )}`}
    </>
  )
}

// TODO: Move messageActionContent to logic directory
export const messageActionContent = (
  messageActions: { userId: string; action: MessageActionTypes }[],
) => {
  if (!messageActions?.length) return undefined

  if (messageActions.length === 1)
    return <SingleUserAction messageActions={messageActions} />

  if (messageActions.length === 2)
    return <DoubleUserAction messageActions={messageActions} />

  return <ManyUserAction messageActions={messageActions} />
}

export const useHallMessageAction = (isGroup: boolean, roomId: string) => {
  if (!isGroup) return undefined
  //  eslint-disable-next-line react-hooks/rules-of-hooks
  const messageActions = useMessageAction(roomId)
  return messageActionContent(messageActions)
}
